import { render, staticRenderFns } from "./CurrentMonthConsumptionWidget.global.vue?vue&type=template&id=7fc94712&lang=pug&"
import script from "./CurrentMonthConsumptionWidget.global.vue?vue&type=script&lang=ts&"
export * from "./CurrentMonthConsumptionWidget.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports